import { Flex } from '@fullstory/components';
import { classNames } from '@fullstory/util/fmt';
import React, { PropsWithChildren } from 'react';
import cssColors from './colors.module.scss';
import css from './index.module.scss';

export interface NotificationDotProps {
  /**
   * Determines if the notification dot is shown or hidden
   */
  enabled?: boolean;
  /**
   * Size in pixels of the dot
   *
   * @default 10
   */
  size?: number;
  /**
   * Offset from the top of the container
   *
   * @default -4
   */

  top?: number;
  /**
   * Offset from the bottom of the container
   */
  bottom?: number;
  /**
   * Offset from the left of the container
   */
  left?: number;
  /**
   * Offset from the right of the container
   *
   * @default -4
   */
  right?: number;
  /**
   * Sets the color of the dot from theme engine "special" colors
   */
  color?: keyof typeof cssColors;
}

export const NotificationDot: React.FC<PropsWithChildren<NotificationDotProps>> = ({
  enabled = false,
  top = -4,
  right = -4,
  bottom,
  left,
  size = 10,
  color = 'cta',
  children,
}) => (
  <Flex
    data-component="NotificationDot"
    className={css.iconWrapper}
    alignItems="flex-start"
    justifyContent="flex-end"
  >
    <div
      className={classNames(cssColors[color], css.dot, { [css.enabled]: enabled })}
      style={{ width: size, height: size, top, right, bottom, left }}
    />
    {children}
  </Flex>
);
